import { Box } from "@chakra-ui/react";
import { POSTS_TYPE_VALUE_EVENT } from "@raiden/library/constants/posts";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { CenteredContent } from "../../../../components/CenteredContent";
import { PageLayout } from "../../../../components/PageLayout";
import { PostSearch } from "../../Common/Search";

/**
 * @typedef {Object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/PostCategory").PostCategory[]>>} swrResponsePostCategories
 */
/**
 * @param {Props} props
 */
export function EventsSearch({ swrResponsePostCategories }) {
  const intl = useIntl();

  const breadcrumbItems = useMemo(() => {
    /** @type {import("../../../../components/Breadcrumb").BreadcrumbItem[]} */
    const items = [
      {
        title: intl.formatMessage({ defaultMessage: "Accueil" }),
        url: generateFrontPath({ id: "@front.home" }),
      },
      {
        title: intl.formatMessage({ defaultMessage: "L'agenda" }),
        url: generateFrontPath({ id: "@front.events" }),
      },
    ];
    return items;
  }, [intl]);

  return (
    <PageLayout
      title={intl.formatMessage({ defaultMessage: "L'agenda" })}
      breadcrumbItems={breadcrumbItems}>
      <Box px="1rem">
        <CenteredContent>
          <PostSearch
            postType={POSTS_TYPE_VALUE_EVENT}
            swrResponsePostCategories={swrResponsePostCategories}
          />
        </CenteredContent>
      </Box>
    </PageLayout>
  );
}
